/** @format */

import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// GA4 page_view for in-app navigation.
//
// gtag("config") in public/index.html sends one page_view when the site first
// loads. Moving between pages after that is a client-side route change, and
// nothing reported it: watching the live site (Oct 2026), roller -> /shop sent
// only GTM's "Page clicks" event, so GA4 saw one page per visit.
//
// If "Page changes based on browser history events" is ever switched on in
// the GA4 stream's enhanced measurement, remove this or every page counts
// twice.
//
// Staff and non-production hosts are already covered: the analytics gate in
// index.html sets ga-disable for them, so these calls send nothing.
const RouteAnalytics = () => {
	const { pathname, search } = useLocation();
	const isFirst = useRef(true);

	useEffect(() => {
		if (isFirst.current) {
			isFirst.current = false; // the config call already counted this one
			return undefined;
		}
		// Helmet sets the new <title> in requestAnimationFrame; wait for it.
		const id = setTimeout(() => {
			if (typeof window.gtag !== "function") return;
			window.gtag("event", "page_view", {
				page_location: window.location.href,
				page_path: pathname + search,
				page_title: document.title,
			});
		}, 300);
		return () => clearTimeout(id);
	}, [pathname, search]);

	return null;
};

export default RouteAnalytics;
